import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter } from 'rxjs';

import { AuctionTickerService } from '@core/services/auction-ticker.service';

import { MarketplaceShellComponent } from '@shared/components/marketplace-shell/marketplace-shell.component';
import { ToastHostComponent } from '@shared/components/toast-host/toast-host.component';

/**
 * Root component - wraps routed pages in the marketplace shell unless the
 * deepest matched route opts out via `data.hideShell` (e.g. 404), and renders
 * the global toast host.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MarketplaceShellComponent, ToastHostComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected readonly showShell = signal(true);

  constructor() {
    // Instantiate the app-wide 1-second auction clock (root-scoped service) so
    // every countdown in the app ticks from the moment the app boots.
    inject(AuctionTickerService);

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        let snapshot = this.route.snapshot;
        while (snapshot.firstChild) snapshot = snapshot.firstChild;
        this.showShell.set(!snapshot.data['hideShell']);
      });
  }
}
